import React from "react";
import { Button } from "bootstrap";
import  Main  from "./contactus/views/Main/Main"
const ContactUs = () => {

    return (
        <Main />
     );

}

export default ContactUs;